import { APP_CONFIG, ROUTES } from '@/constants/app';
import { cn } from '@/utils/cn';
import { Sparkles } from 'lucide-react';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'innov_paie_seen_version';

export function VersionBubble() {
  const navigate = useNavigate();
  const [hasNewVersion, setHasNewVersion] = useState(false);

  useEffect(() => {
    const seenVersion = localStorage.getItem(STORAGE_KEY);
    setHasNewVersion(seenVersion !== APP_CONFIG.version);
  }, []);

  const handleClick = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, APP_CONFIG.version);
    setHasNewVersion(false);
    navigate(ROUTES.CHANGELOG);
  }, [navigate]);

  return (
    <button
      onClick={handleClick}
      aria-label={`Voir les nouveautés de la version ${APP_CONFIG.version}`}
      className={cn(
        // La version n'est pas indispensable au parcours mobile et la bulle
        // fixe masquait les liens légaux du pied de page. Le changelog reste
        // disponible dans la navigation sur les écrans plus larges.
        'fixed right-5 bottom-20 z-40 hidden items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium shadow-lg transition-all hover:scale-105 active:scale-95 sm:flex',
        hasNewVersion
          ? 'border-brand-200 bg-brand-50 text-brand-700 hover:bg-brand-100 hover:shadow-brand-200/50'
          : 'border-neutral-200 bg-white text-neutral-500 hover:bg-neutral-50 hover:text-neutral-700'
      )}
    >
      {hasNewVersion && (
        <span className="relative flex h-2 w-2">
          <span className="bg-brand-500 absolute inline-flex h-full w-full animate-ping rounded-full opacity-75" />
          <span className="bg-brand-500 relative inline-flex h-2 w-2 rounded-full" />
        </span>
      )}
      {hasNewVersion && <Sparkles className="h-3.5 w-3.5" />}
      <span>v{APP_CONFIG.version}</span>
    </button>
  );
}
